/* eslint-disable import/no-cycle */
import { Logger } from '@saviynt/common';
import axios from 'axios';

import { httpService } from '../../../http-service/httpService';
import {
  CAMPAIGN_TYPES,
  CAMPAIGNTYPE_ENTITLEMENTOWNER,
  GROUP_BY_APP_VALUE,
} from '../../../utils/constant';
import { executeBackNavigation } from '../../../utils/utils';
import {
  setBulkActionIsDisabled,
  setIsBulkActionEnabled,
} from '../bulkaction/action';
import {
  setAllowedRows,
  setBackNavigationConfig,
  setCampaignKey,
  setCertificationName,
  setCommonError,
  setGlobalDateFormat,
  setIsAuditor,
} from '../global/action';
import {
  setAutoRevokeList,
  setCertficationEndDate,
  setCertficationStartDate,
  setIndividualComments,
  setReassignCongfig,
} from '../lineactions/action';
import {
  setIsSubmittingReviewAndSubmit,
  setReviewAndSubmitConfig,
} from '../reviewandsubmit/action';
import {
  setIsCertificationActionable,
  setIsSaviEnabled,
} from '../savicompanion/action';
import {
  AXIOS_TIMEOUT,
  CERT_DETAILS_COLUMNS_TO_SHOW,
  CERT_DETAILS_LISTS_LOADING,
  CERT_DETAILS_REFRESH_SUCCESS,
  CERT_DETAILS_VIEW_API_ERROR,
  CERT_DETAILS_VIEW_API_UNAUTHORIZED_ERROR,
  CERT_DETAILS_VIEW_LOADING,
  DATA_FETCH_ERROR,
  FORCED_CANCELLATION,
  FORCED_CANCELLATION_MESSAGE,
  SET_CERT_DETAILS_CAMPAIGN_KEY,
  SET_CERT_DETAILS_LISTS,
  SET_CERT_DETAILS_TERMINATE_COMMENTS,
  SET_CERT_DETAILS_TERMINATE_CONFIG_MAP,
  SET_CERT_ITEMS_OFFSET_COUNT,
  SET_CERT_TRUST_SCORE_FLAG,
  SET_PREDEFINED_COMMENTS,
  tabMapping,
} from '../types';
import {
  URL_AUDIT_HISTORY_API,
  URL_CLEAR_FILTER_API,
  URL_ES_CHECK_API,
  URL_FETCH_USER_API,
  URL_FILTER_SEARCH_API,
  URL_ITEMS_API,
  URL_PREDEFINED_COMMENT_API,
  URL_REFRESH_API,
  URL_UPDATE_FILTER_API,
  URL_VIEW_API,
} from '../urls';
import { setCreateFilterActionMap } from '../viewcontrols/action';

let cancelTokenForCertDetailsData;

const ALLOWED_CERTIFICATION_STATUS_FOR_REVIEW_AND_SUBMIT = [0, 1, 2];
const ALLOWED_CAMPAIGN_COMMENT_FOR_REVIEW_AND_SUBMIT = ['1', '[1, 2]'];
const reviewAndSubmitESignatureLoginCredentialsField = 'userName';

const axiosTimeoutConfig = { timeout: AXIOS_TIMEOUT };

export const setViewApiError = (status) => (dispatch) => {
  dispatch({
    type: CERT_DETAILS_VIEW_API_ERROR,
    payload: { isError: status },
  });
};

export const setColumnsToShow = (colToShow) => (dispatch) => {
  dispatch({
    type: CERT_DETAILS_COLUMNS_TO_SHOW,
    payload: colToShow,
  });
};

export const setCertsDetailListLoading = (status) => (dispatch) => {
  dispatch({
    type: CERT_DETAILS_LISTS_LOADING,
    payload: status,
  });
};

export const getRefreshedCertDetails = (eids) => async (dispatch, getState) => {
  const {
    global: { certKey },
    tabs: { tabData },
    lineActions: { reassignConfigMap },
  } = getState().certifications.details;
  const { isSecondaryCertifierLoggedIn } = reassignConfigMap;
  // Get the active tab key
  const activeTabKey = tabData?.find((tab) => tab.isActive).key;
  const activeTab = tabMapping[activeTabKey] || 'all';

  const body = {
    certkey: certKey,
    max: String(Math.max(1, eids?.length)),
    offset: '0',
    tab: activeTab,
    requestOrigin: 'UI',
    eids,
    refresh: '1',
  };

  try {
    const { data } = await httpService.post(
      `${URL_REFRESH_API}?refresh=1`,
      body,
      axiosTimeoutConfig
    );

    const { msg, results } = data;

    if (msg !== 'Success' && !isSecondaryCertifierLoggedIn) {
      throw Error('Failed to refresh the associated items');
    }

    setTimeout(() => {
      dispatch({ type: CERT_DETAILS_REFRESH_SUCCESS, payload: false });
    }, 2000);
    dispatch({ type: CERT_DETAILS_REFRESH_SUCCESS, payload: true });

    return results;
  } catch (error) {
    dispatch({ type: CERT_DETAILS_REFRESH_SUCCESS, payload: false });
    throw Error(error);
  }
};

export const getCertDetailsData =
  (certKey, columnNames, max, offset, searchText = '') =>
  async (dispatch, getState) => {
    const {
      core: { isLoading, campaignType },
      tabs: { tabData },
      viewControls: { groupByOptions, dynamicSortFilter },
    } = getState().certifications.details;

    // Get the active tab key
    const activeTabKey = tabData?.find((tab) => tab.isActive).key;
    const activeTab = tabMapping[activeTabKey] || 'all';
    const { sortByColumn, sortDirection } = dynamicSortFilter;
    const selectedGroupByValue = groupByOptions?.find(
      (option) => option.isChecked
    )?.value;

    const isEOCampaign =
      CAMPAIGN_TYPES[campaignType] === CAMPAIGNTYPE_ENTITLEMENTOWNER;

    const body = {
      certkey: certKey,
      max: `${max}`,
      offset: `${offset}`,
      requestOrigin: 'UI',
      sSearch: `${searchText}`,
      columnsToShow: columnNames,
      tab: activeTab,
      group_by: selectedGroupByValue,
    };

    // pass group by in payload exclude it for EO campaign
    if (!isEOCampaign) {
      body.group_by = selectedGroupByValue;
    }

    if (sortByColumn && sortDirection) {
      body.columnNameToSort = sortByColumn;
      body.order = sortDirection;
    }

    if (!isLoading) {
      dispatch({ type: CERT_DETAILS_LISTS_LOADING, payload: true });
    }

    dispatch(setCommonError({ isError: false, error: null }));

    dispatch({
      type: SET_CERT_ITEMS_OFFSET_COUNT,
      payload: offset,
    });

    try {
      if (cancelTokenForCertDetailsData) {
        cancelTokenForCertDetailsData.cancel(FORCED_CANCELLATION_MESSAGE);
      }

      cancelTokenForCertDetailsData = axios.CancelToken.source();

      if (!body?.columnsToShow) {
        return FORCED_CANCELLATION;
      }

      const { data } = await httpService.post(URL_ITEMS_API, body, {
        cancelToken: cancelTokenForCertDetailsData.token,
      });

      const { results: tempData, total } = data;

      if (isEOCampaign) {
        // EO campaign condition check
        dispatch({
          type: SET_CERT_DETAILS_LISTS,
          payload: {
            results:
              selectedGroupByValue === GROUP_BY_APP_VALUE
                ? tempData?.map((node) => ({
                    ...node,
                    ROW_TYPE: 'EO_END_POINT',
                    CERT_ENTITLEMENT_VALUEKEY: node?.ENDPOINTKEY,
                    isEndPoint: node?.isEndpoint,
                    rowNotToShow: '0',
                  }))
                : tempData?.map((node) => ({
                    ...node,
                    ROW_TYPE: node.ROW_TYPE?.toString(),
                    CERT_ENTITLEMENT_VALUEKEY:
                      node.CERT_ENTITLEMENT_VALUEKEY?.toString(),
                  })),
            total,
            searchText,
            error: null,
          },
        });
      } else {
        dispatch({
          type: SET_CERT_DETAILS_LISTS,
          payload: {
            results:
              selectedGroupByValue === GROUP_BY_APP_VALUE
                ? tempData?.map((node) => ({
                    ...node,
                    CERT_USERKEY: node?.ENDPOINTKEY,
                    isEndPoint: node?.isEndpoint,
                    rowNotToShow: '0',
                  }))
                : tempData,
            total,
            searchText,
            error: null,
          },
        });
      }

      dispatch({ type: CERT_DETAILS_LISTS_LOADING, payload: false });
    } catch (error) {
      if (error?.code !== FORCED_CANCELLATION) {
        dispatch({
          type: SET_CERT_DETAILS_LISTS,
          payload: {
            results: null,
            error: DATA_FETCH_ERROR,
          },
        });

        dispatch({ type: CERT_DETAILS_LISTS_LOADING, payload: false });
      }

      dispatch(
        setCommonError({
          isError: error?.code !== FORCED_CANCELLATION,
          error:
            error?.code === FORCED_CANCELLATION
              ? FORCED_CANCELLATION_MESSAGE
              : DATA_FETCH_ERROR,
        })
      );
    }

    return true;
  };

/**
 * Name: checkEsConnection
 * Description: calls /checkEsConnection API and get the status of the es
 * Returns: sets the values in the store
 */
export const checkEsConnection = () => async () => {
  try {
    const { data } = await httpService.post(URL_ES_CHECK_API);

    if (!data || !data.response) {
      throw Error('ES Check Failed');
    }
  } catch (error) {
    Logger.error('Error: ', Error(error.message));

    throw error;
  }
};

/**
 * Name: getViewDetails
 * Description: calls /view API and get the details of it
 * Returns: sets the values in the store
 */
export const getViewDetails = (certKey) => async (dispatch, getState) => {
  const { certsListGen2 } = getState().user;

  const body = { certkey: certKey };

  dispatch({ type: CERT_DETAILS_VIEW_LOADING, payload: true });
  dispatch({
    type: CERT_DETAILS_VIEW_API_ERROR,
    payload: { isError: false, error: null },
  });

  try {
    const { data } = await httpService.post(URL_VIEW_API, body);

    const {
      campaignType,
      certificationStatus,
      consulteeLoggedIn,
      defaultReassigneeName,
      enableloginSignature,
      objectsToBeIncluded,
      hasCampaignLevelAccess,
      hasOnlyCertifierLevelAccess,
      campaignKey,
      createFilterActionMap,
      certifierUsername,
      certification_name: certificationName,
      certifierUserKey,
      configMap,
      showBulkCheckBox,
      noOfTries,
      globalDateFormat,
      enableCertificationTrustModel,
      enableIndividualCommentsForUsers,
      enableIndividualCommentsForAccountEntitlementRoles,
      enableIndividualCommentsForAccounts,
      enableIndividualCommentsForEntitlements,
      enableIndividualCommentsForChildEnt,
      role_AuditorLoggedIn: roleAuditorLoggedIn,
      enableReassignUser,
      defaultReassignee,
      enableReassignStep2,
      campaignMap,
      savi_enabled: saviEnabled,
      useJrmRecommendationJSON,
      enableAccessVerificationOnly,
      enableEmploymentVerificationOnly,
      isSecondaryCertifierLoggedIn,
      isSecondaryCertifierDelegateLoggedIn,
      showConsultStep1,
      showConsultStep2,
    } = data;

    if (configMap?.NEW_CERT_UX === '1') {
      /* empty */
    } else {
      executeBackNavigation({
        hasCampaignLevelAccess,
        roleAuditorLoggedIn,
        hasOnlyCertifierLevelAccess,
        consulteeLoggedIn,
        campaignKey,
        certsListGen2,
      });
    }

    const isCertificationActionable = Boolean(
      !roleAuditorLoggedIn &&
        (ALLOWED_CERTIFICATION_STATUS_FOR_REVIEW_AND_SUBMIT.includes(
          Number(certificationStatus)
        ) ||
          configMap?.hasValidAccess)
    );
    const shouldShowReviewAndSubmitButton = isCertificationActionable;
    const isTrustScoreEnabled = Boolean(
      enableCertificationTrustModel || useJrmRecommendationJSON === 'TRUE'
    );
    const reassignConfig = {
      enableReassignUser,
      enableReassignStep2,
      defaultReassignee: defaultReassignee || configMap.defaultReassignee, // defaultReassignee
      defaultReassigneeName,
      enableIndividualCommentsForAccountEntitlementRoles,
      enableIndividualCommentsForUsers,
      showReassignPopup: configMap.SHOWREASSIGNPOPUP,
      ENABLEREASSIGNUSER: configMap?.ENABLEREASSIGNUSER,
      SHOWEMPLOYEESTATUSOPTIONINSTEP1:
        configMap?.SHOWEMPLOYEESTATUSOPTIONINSTEP1,
      certifierUserKey,
      enableAccessVerificationOnly,
      enableEmploymentVerificationOnly,
      isSecondaryCertifierLoggedIn,
      showUpdateAccountOwner: configMap.UPDATEUSERTABLE,
      showConsultStep1,
      showConsultStep2,
    };

    const getAutoRevokeList = () => {
      const autoRevokeList = [];

      if (configMap?.LOCKTASKEXPIRE === '1') autoRevokeList.push('Terminated');
      if (configMap?.CREATEREVOKETASKFORUNRESPONDEDCERTIFICATIONITEMS === '1')
        autoRevokeList.push('Unresponded');
      if (configMap?.CREATETASKFORCERTIFIEDONEXPIRY === '1')
        autoRevokeList.push('Approved');

      return autoRevokeList;
    };

    const autoRevokeList = getAutoRevokeList();

    dispatch({
      type: SET_CERT_DETAILS_CAMPAIGN_KEY,
      payload: campaignType,
    });
    dispatch(setReassignCongfig(reassignConfig));
    dispatch(setGlobalDateFormat(globalDateFormat));
    dispatch(setAllowedRows(objectsToBeIncluded));
    dispatch(setCampaignKey(campaignKey));
    dispatch(
      setBackNavigationConfig({
        hasCampaignLevelAccess,
        roleAuditorLoggedIn,
        hasOnlyCertifierLevelAccess,
        consulteeLoggedIn,
        campaignKey,
        certsListGen2,
      })
    );
    dispatch(setAutoRevokeList(autoRevokeList));
    dispatch(setCertficationStartDate(campaignMap?.startDate));
    dispatch(setCertficationEndDate(campaignMap?.endDate));
    dispatch({
      type: SET_CERT_TRUST_SCORE_FLAG,
      payload: isTrustScoreEnabled
        ? {
            enableCertificationTrustModel,
            useJrmRecommendationJSON,
          }
        : undefined,
    });
    dispatch(setCertificationName(certificationName));
    dispatch({
      type: SET_CERT_DETAILS_TERMINATE_CONFIG_MAP,
      payload: configMap,
    });
    dispatch(setIsAuditor(roleAuditorLoggedIn || false));
    dispatch(setBulkActionIsDisabled(roleAuditorLoggedIn || false));
    dispatch({
      type: SET_CERT_DETAILS_TERMINATE_COMMENTS,
      payload: enableIndividualCommentsForUsers,
    });

    if (CAMPAIGN_TYPES[campaignType] === CAMPAIGNTYPE_ENTITLEMENTOWNER) {
      dispatch(setIsBulkActionEnabled(showBulkCheckBox));
    } else {
      dispatch(
        setIsBulkActionEnabled(
          Boolean(
            typeof configMap?.SHOWCHECKBOXBULK === 'string' &&
              configMap?.SHOWCHECKBOXBULK?.length > 0
          )
        )
      );
    }

    dispatch(
      setReviewAndSubmitConfig({
        certificationStatus: Number(certificationStatus),
        hasValidAccess: Boolean(configMap?.hasValidAccess),
        primaryCertifier:
          !isSecondaryCertifierDelegateLoggedIn &&
          !isSecondaryCertifierLoggedIn &&
          !consulteeLoggedIn,
        primaryCertifierName: certifierUsername,
        withESignature: Boolean(
          Number(configMap.ENABLE_ESIGNATURE) || Number(enableloginSignature)
        ),
        isCommentEnabled: Boolean(
          ALLOWED_CAMPAIGN_COMMENT_FOR_REVIEW_AND_SUBMIT?.includes(
            configMap?.CAMPAIGN_LOCK_COMMENTS
          )
        ),
        userAttribute:
          configMap.USERATTRIBUTE_ESIGNATURE ||
          reviewAndSubmitESignatureLoginCredentialsField,
        enableloginSignature,
        noOfTries,
      })
    );
    dispatch(
      setIndividualComments({
        enableIndividualCommentsForUsers,
        enableIndividualCommentsForAccountEntitlementRoles,
        enableIndividualCommentsForAccounts,
        enableIndividualCommentsForEntitlements,
        enableIndividualCommentsForChildEnt,
      })
    );
    dispatch(
      setIsSubmittingReviewAndSubmit(Boolean(shouldShowReviewAndSubmitButton))
    );
    dispatch(setIsSaviEnabled(saviEnabled === '1'));
    dispatch(setIsCertificationActionable(isCertificationActionable));
    dispatch(setCreateFilterActionMap(createFilterActionMap));
  } catch (error) {
    dispatch(setCampaignKey(null));

    if (error === 403) {
      dispatch({
        type: CERT_DETAILS_VIEW_API_UNAUTHORIZED_ERROR,
        payload: { isError: true },
      });
    } else {
      dispatch({
        type: CERT_DETAILS_VIEW_API_ERROR,
        payload: { isError: true },
      });
    }

    dispatch(setCertificationName(null));
    dispatch(setCertficationStartDate(null));
    dispatch(setCertficationEndDate(null));
    dispatch(setAutoRevokeList([]));
    dispatch({
      type: SET_CERT_DETAILS_TERMINATE_CONFIG_MAP,
      payload: null,
    });
    dispatch({
      type: SET_CERT_DETAILS_TERMINATE_COMMENTS,
      payload: null,
    });

    throw error;
  } finally {
    dispatch({ type: CERT_DETAILS_VIEW_LOADING, payload: false });
  }
};

export const clearCertsSession = (certKey) => async (dispatch) => {
  const body = {
    certkey: certKey,
    clearAllCustomSessionAttributes: 'true',
  };

  try {
    const { data } = await httpService.post(
      URL_UPDATE_FILTER_API,
      body,
      axiosTimeoutConfig
    );
    const { response } = data;

    if (!response || response !== 'Success') {
      throw new Error('Failed to clear session objects');
    }
  } catch (error) {
    dispatch(
      setCommonError({
        isError: true,
        error: 'Failed to clear session objects',
      })
    );
  }
};

export const searchFilterValuesByText = (requestPayload) => async () => {
  try {
    const { data } = await httpService.post(
      URL_FILTER_SEARCH_API,
      requestPayload
    );

    return data;
  } catch (error) {
    throw Error(error);
  }
};

// to clear or remove the chip filter
export const clearChipFilter = (requestPayload) => async () => {
  try {
    const { data } = await httpService.post(
      URL_CLEAR_FILTER_API,
      requestPayload
    );

    return data;
  } catch (error) {
    throw Error(error);
  }
};

export const getUsersListWithSearch = (requestPayload) => async () => {
  try {
    const { data } = await httpService.post(URL_FETCH_USER_API, requestPayload);

    return data;
  } catch (error) {
    throw Error(error);
  }
};

export const getAuditHistoryData = (requestPayload) => async () => {
  try {
    const { data } = await httpService.post(
      URL_AUDIT_HISTORY_API,
      requestPayload
    );

    return data;
  } catch (error) {
    throw Error(error);
  }
};

// TODO: @Jacob, Should not need certKeyProvided, figure out why The redux getter is not working
export const getPredefinedComments =
  (action, certKeyProvided) => async (dispatch, getState) => {
    const { certKey } = getState().certifications.details.global;
    const body = { certkey: certKey || certKeyProvided };

    try {
      const { data } = await httpService.post(
        URL_PREDEFINED_COMMENT_API,
        body,
        axiosTimeoutConfig
      );

      if (data?.response === 'Success') {
        // update redux store
        dispatch({
          type: SET_PREDEFINED_COMMENTS,
          payload: {
            comments: data?.result,
          },
        });
      }

      return true;
    } catch (error) {
      Logger.log(error);

      throw Error(error);
    }
  };
